import React from 'react';
import { 
  RocketLaunchIcon, 
  LightBulbIcon, 
  UserGroupIcon, 
  HeartIcon,
  ChartBarIcon
} from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import StageCards from '../../../components/playbooks/StageCards';
import { getPlaybookById } from '../../../data/playbookTaxonomy';

// Stage icons mapping
const stageIcons = {
  'stage-1': <LightBulbIcon className="h-6 w-6" />,
  'stage-2': <UserGroupIcon className="h-6 w-6" />,
  'stage-3': <HeartIcon className="h-6 w-6" />,
  'stage-4': <ChartBarIcon className="h-6 w-6" />
};

const FeedbackCultureHowToExecute = () => {
  // Get stage sections from the taxonomy
  const playbook = getPlaybookById('feedback-culture');
  const stageSections = playbook?.sections.filter(section => section.id.startsWith('stage-')) || [];

  return (
    <div className="space-y-8">
      <PlaybookSection title="How To Execute" icon={<RocketLaunchIcon className="h-7 w-7 text-primary-light" />} heading>
        <div className="prose prose-invert max-w-none mb-8">
          <p className="text-gray-300">
            Clicking into each tile, you will find a concise distillation of 25+ years experience that helps guide you through each stage. 
            If you have any questions or need help, please get in touch.
          </p>
        </div>

        <StageCards 
          stages={stageSections}
          icons={stageIcons}
          playbookId="feedback-culture"
          introText="Our step-by-step guide through each stage of implementing a feedback culture. Select a stage to dive deeper into the process."
        />

        <div className="mt-4 p-4 rounded-lg bg-gray-800/50 border border-gray-700/50 text-sm text-gray-300">
          <p>Need assistance implementing a feedback culture? <a href="mailto:john@openorg.fyi" className="text-primary hover:text-primary-light underline">Get in touch</a> for personalized guidance.</p>
        </div>
      </PlaybookSection>
    </div>
  );
};

export default FeedbackCultureHowToExecute; 